export default __webpack_public_path__ + "static/media/z040ma0a.12c8d4e8.mp3";